<div class="filter-picker-container" #filterPicker>
    <button type="button" class="btn-simple btn-simple-primary" (click)="showFilterList()">
        <span class="text-capitalize">            
            <ng-container *ngIf="helperLabel">{{ helperLabel | translate }}</ng-container> {{ selectedFilter.label }}
        </span>
        <i aria-hidden="true" class="icon-edponline-Bop-073 rotate-360 icon"></i>
    </button>

    <div *ngIf="showFilterPicker" class="d-flex flex-column filter-picker-list">
        <button *ngFor="let item of filterList" type="button" class="btn-simple btn-simple-outline"
            (click)="selectFilter(item)" [ngClass]="{'btn-simple-primary': item.value === selectedFilter.value}">
            <span>{{ item.label }}</span>
        </button>
    </div>

</div>
